<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="periodo-escolar" titulo="Período Escolar / Coordinación" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh; max-width: 83.4vw;" >
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="contador_cambio = 0; hacer = tieneid ? false : true; ctrl.cargarCatalogo('modalidades', 'modalidad'); ctrl.cargarCatalogo('ciclos_escolares', 'ciclo-escolar'); ctrl.cargarCatalogo('tipos_periodos', 'tipo-periodo', 'cambio_periodo'); ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar', 'procesa_periodo');"></a>
                    <a id="cambio_periodo" (click)="cambio_periodo(ctrl.tipos_periodos, ctrl.dato.controls.periodos_escolares_colegiaturas);"></a>
                    <a id="procesa_periodo" (click)="procesa_periodo(ctrl.periodos_escolares);"></a>
                    <a id="recargar" (click)="actualizar_disabled()"></a>

                    <div class="tabs is-boxed">
                      <ul>
                        <li [ngClass]="{ 'is-active' : tab == 1}">
                          <a (click)="tab=1">
                            <span class="icon ">
                              <i class="fa fa-home"></i>
                            </span>
                            <span>General</span>
                          </a>
                        </li>

                        <li [ngClass]="{ 'is-active' : tab == 2}">
                          <a (click)="tab=2">
                            <span class="icon ">
                              <i class="fa fa-bookmark-o"></i>
                            </span>
                            <span>Nota para alumnos</span>
                          </a>
                        </li>

                        <li [ngClass]="{ 'is-active' : tab == 3}">
                          <a (click)="tab=3">
                            <span class="icon ">
                              <i class="fa fa-bookmark-o"></i>
                            </span>
                            <span>Nota para docentes</span>
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div [ngClass]="{ 'is-hidden': tab != 1}">
                      <div class="columns">
                          <div class="column is-4">
                              <div class="field">
                                  <label class="label">Modalidad:</label>
                                  <div class="control has-icons-left has-icons-right">
                                      <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('modalidades_id').hasError('required')}">
                                          <select class="select"  name="modalidades_id" formControlName="modalidades_id" >
                                              <option *ngFor="let val of ctrl.modalidades" value="{{val.id}}">{{ val.nombre }} ({{val.duracion_meses}} Meses)</option>
                                          </select>
                                      </div>
                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('modalidades_id').hasError('required')">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('modalidades_id').hasError('required')">Este campo es requerido.</span>
                                  </div>
                              </div>
                          </div>
                          <div class="column is-4">
                              <div class="field">
                                  <label class="label">Tipo periodo:</label>
                                  <div class="control has-icons-left has-icons-right">
                                      <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('tipos_periodos_id').hasError('required')}">
                                          <select class="select"  name="tipos_periodos_id" formControlName="tipos_periodos_id"
                                          (change)="limpiar_pagos(); cambio_periodo(ctrl.tipos_periodos, ctrl.dato.controls.periodos_escolares_colegiaturas)">
                                              <option *ngFor="let val of ctrl.tipos_periodos" value="{{val.id}}">{{ val.nombre }}</option>
                                          </select>
                                      </div>
                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('tipos_periodos_id').hasError('required')">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('tipos_periodos_id').hasError('required')">Este campo es requerido.</span>
                                  </div>
                              </div>
                          </div>
                          <div class="column is-4">
                            <div class="field">
                              <br>
                              <div class="b-checkbox is-info" title="Si la casilla está desmarcada, el período escolar no se muestra para muchos filtros en otros módulos y tampoco podrá agregarle grupos">
                                <input id="vigente" class="styled" [checked]="ctrl.dato.get('vigente').value == '1' ? true : false" (change)="ctrl.dato.get('vigente').patchValue(ctrl.dato.get('vigente').value == '1' ? '0' : '1')" type="checkbox">
                                <label for="vigente">
                                  Activo o Vigente
                                </label>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div class="columns">
                          <div class="column is-4">
                              <div class="field">
                                  <label class="label">Nombre:</label>
                                  <p class="control has-icons-left has-icons-right">
                                      <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}" placeholder="Este campo se llena al selecionar la fecha de inicio y fin"
                                          formControlName="nombre" readonly>
                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required')">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required')">Este campo es requerido.</span>
                                  </p>
                              </div>
                          </div>
                          <div class="column is-4">
                            <div class="field">
                                <label class="label">Periodo escolar anterior: <small>{{ periodo_anterior_nombre }}</small></label>
                                <a id="" (click)="cambio_periodo_escolar(ctrl.periodos_escolares);"></a>
                                <div class="control has-icons-left has-icons-right">
                                    <!-- <div class="select">
                                        <select class="select" #periodoAnterior name="periodo_escolar_anterior" formControlName="periodo_escolar_anterior" (change)="cambio_periodo_escolar(ctrl.periodos_escolares);">
                                          <option value=""> SELECCIONE </option>
                                          <option *ngFor="let val of ctrl.periodos_escolares" value="{{val.id}}"> {{ val.nombre }} / {{ val.modalidades?.nombre }} / {{ val.tipos_periodos?.nombre }}</option>
                                        </select>
                                    </div> -->

                                    <ng-select2 [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                                      [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.periodo_escolar_anterior.value"
                                      (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.periodo_escolar_anterior);"
                                      [data]="ctrl.periodos_escolares"></ng-select2>
                                </div>
                            </div>
                        </div>
                        <div class="column is-4">
                          <label class="label">Ciclo escolar:</label>
                          <div class="control has-icons-left has-icons-right">
                              <!-- <span class="icon is-small is-left">
                                <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_carrera"></i>
                              </span> -->

                              <!-- <ng-select2 [disabled]="ctrl.ciclos_escolares ? ctrl.ciclos_escolares.length == 0 ? true : false : true" [options]="ctrl.optionSelect" name="ciclos_escolares_id" [value]="ciclos_escolares_id"
                              (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.ciclos_escolares_id); autovalor_ciclo();"
                              [data]="ctrl.ciclos_escolares"></ng-select2> -->

                              <ng-select2 [disabled]="ctrl.ciclos_escolares ? ctrl.ciclos_escolares.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.ciclos_escolares_id.value"
                                (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.ciclos_escolares_id);"
                                [data]="ctrl.ciclos_escolares"></ng-select2>

                              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('ciclos_escolares_id').hasError('required') ">
                                  <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="ctrl.dato.get('ciclos_escolares_id').hasError('required') ">Este campo es requerido.</span>
                          </div>
                      </div>
                      </div>
                      <div class="columns">
                          <div class="column is-4">
                              <div class="field">
                                  <label class="label">Fecha inicio:</label>
                                  <p class="control has-icons-left has-icons-right">
                                      <input class="input" formControlName="fecha_inicio" type="date" [attr.min]="MinDate"
                                          [ngClass]="{'is-danger': ctrl.dato.get('fecha_inicio').hasError('required')}"  (ngModelChange)="obtener_nombre();"  />


                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha_inicio').hasError('required') ">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('fecha_inicio').hasError('required') ">Este campo es requerido.</span>
                                  </p>
                              </div>
                          </div>
                          <div class="column is-4">
                              <div class="field">
                                  <label class="label">Fecha fin:</label>
                                  <p class="control has-icons-left has-icons-right">
                                      <input class="input" formControlName="fecha_fin" type="date" [attr.min]="ctrl.dato.get('fecha_inicio').value"
                                          [ngClass]="{'is-danger': ctrl.dato.get('fecha_fin').hasError('required')}" (ngModelChange)="obtener_nombre();"/>


                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha_fin').hasError('required')">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('fecha_fin').hasError('required')">Este campo es requerido.</span>
                                  </p>
                              </div>
                          </div>

                          <div class="column is-4">
                              <div class="field">
                                  <label class="label">Fecha pago reinscripción:</label>
                                  <p class="control has-icons-left has-icons-right">
                                      <input class="input" formControlName="fecha_reinscripcion" type="date" [attr.min]="ctrl.dato.get('fecha_reinscripcion').value"
                                          [ngClass]="{'is-danger': ctrl.dato.get('fecha_reinscripcion').hasError('required')}" />


                                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha_reinscripcion').hasError('required')">
                                          <i class="fa fa-warning"></i>
                                      </span>
                                      <span class="help is-danger" *ngIf="ctrl.dato.get('fecha_reinscripcion').hasError('required')">Este campo es requerido.</span>
                                  </p>
                              </div>
                          </div>
                      </div>

                      <section *ngIf="ctrl.dato.controls.continuado.value==1" class="hero is-info">
                          <div class="hero-body">
                              <p class="title">
                                  <span class="icon is-medium ng-star-inserted">
                                      <i class="fa fa-info-circle"></i>
                                  </span>
                                  Información
                              </p>
                              <p class="subtitle">
                                  El periodo escolar ha sido "continuado", es decir, se creó otro periodo que le sucede en la linea de tiempo.
                              </p>
                          </div>
                      </section>

                      <section class="hero" style="background:gainsboro">
                          <div class="hero-body">
                              <p class="title">
                                  <span class="icon is-medium ng-star-inserted">
                                      <i class="fa fa-calendar"></i>
                                  </span>
                                  Programación de pagos
                              </p>
                              <p class="subtitle">
                                  Seleccione la fecha de pago para cada mes
                              </p>
                          </div>
                      </section>
                      <br>

                      <div class="tile is-ancestor" formArrayName="periodos_escolares_colegiaturas" style="max-width: 95vw; overflow: auto;">
                          <div class="tile is-parent" *ngFor="let item of ctrl.dato.controls.periodos_escolares_colegiaturas.controls; let i = index" [formGroupName]="i">
                              <article class="tile is-child box" >
                                  <p class="title">{{(i + 1) | numeroLetra:''}}</p>

                                  <div class="field">
                                      <label class="label">Fecha de pago:</label>
                                      <div class="control has-icons-left has-icons-right">

                                        <input class="input" id="fecha_pago{{i}}" name="fecha_pago{{i}}" formControlName="fecha_pago" type="date"  placeholder="Fecha pago"  [ngClass]="{'is-danger': item.get('fecha_pago').hasError('required')}" />
                                          <span class="icon is-small is-right" *ngIf="item.get('fecha_pago').hasError('required')">
                                              <i class="fa fa-warning"></i>
                                          </span>
                                          <span class="help is-danger" *ngIf="item.get('fecha_pago').hasError('required')">Este campo es requerido.</span>
                                      </div>
                                  </div>
                              </article>
                          </div>
                      </div>
                    </div>

                    <div [ngClass]="{ 'is-hidden': tab != 2}">
                        <ckeditor formControlName="nota_alumnos" debounce="500" [config]="CkeditorConfig"></ckeditor>
                    </div>

                    <div [ngClass]="{ 'is-hidden': tab != 3}">
                        <ckeditor formControlName="nota_docentes" debounce="500" [config]="CkeditorConfig"></ckeditor>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>
